import { motion } from "framer-motion";
import { FOOD } from "./data";
import SectionHeader from "./SectionHeader";

export default function MalnadFood() {
  return (
    <section
      id="food"
      data-testid="food-section"
      className="relative bg-[color:var(--paper)] text-[color:var(--ink)]"
    >
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 py-16 sm:py-20 lg:py-24">
        <SectionHeader
          eyebrow="Section 04 · Authentic Malnad Food"
          title={
            <>
              <span className="font-display-italic text-[color:var(--clay)]">Malnad</span> plates,
              cooked slow, served warm.
            </>
          }
          intro="Coconut, kokum, curry leaves, black pepper, wood-smoke and a lot of patience. Every meal is cooked to order and shared at a common table."
        />

        <div className="mt-12 sm:mt-16 grid grid-cols-12 gap-5 lg:gap-8">
          {FOOD.map((f, i) => {
            const offset = [0, 32, 64, 0, 32][i % 5];
            return (
              <motion.div
                key={f.name}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ delay: (i % 3) * 0.06, duration: 0.85, ease: [0.2, 0.9, 0.2, 1] }}
                className="col-span-12 sm:col-span-6 lg:col-span-4"
                style={{ marginTop: `${offset}px` }}
                data-testid={`food-item-${i}`}
              >
                <div className="group relative aspect-[4/5] overflow-hidden rounded-[20px] bg-[color:var(--forest)]">
                  <img
                    src={f.img}
                    alt={f.name}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-1000 ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-[color:var(--ink)] via-[color:var(--ink)]/70 to-transparent pointer-events-none" />
                  <div className="absolute inset-x-4 sm:inset-x-5 bottom-4 sm:bottom-5 text-[color:var(--paper)]">
                    <div className="font-mono-alt text-[color:var(--sand)] mb-1">
                      Dish · 0{i + 1}
                    </div>
                    <h3 className="font-display text-[1.2rem] sm:text-[1.4rem] leading-tight">
                      {f.name}
                    </h3>
                    <p className="text-[0.78rem] sm:text-[0.82rem] text-[color:var(--paper)]/85 mt-1.5 leading-snug">
                      {f.note}
                    </p>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>

        <p className="mt-12 sm:mt-16 max-w-2xl font-display-italic text-[color:var(--ink)]/70 text-[1.1rem]">
          — Menus vary with the season and the mood of the kitchen. Let us
          know your preference when you book.
        </p>
      </div>
    </section>
  );
}
